import { SetBccEmails } from '@/connection/emails/bcc-emails';
import { RootState } from '@/store/main';
import { serializeError } from '@/store/utils/serialize-error';
import { UpsertBccEmailsRow } from '@/types/email.types';
import { ChannelSettingsReducerCreator } from '../types';

const updateBccEmailsReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, emails }: { channel: number; emails: string[] }, { rejectWithValue, getState }) => {
      try {
        const rootState = getState() as RootState;
        const bccEmails = rootState.channelSettings.bccEmails;
        if (!bccEmails) return;

        const currentEmailsMap: { [key: string]: boolean } =
          bccEmails.reduce((acc, cur) => ({ ...acc, [cur.email]: true }), {}) || [];
        const newEmailsMap: { [key: string]: boolean } = emails.reduce((acc, cur) => ({ ...acc, [cur]: true }), {});

        const toDelete: UpsertBccEmailsRow[] = bccEmails
          .filter((email) => !newEmailsMap[email.email])
          .map((email) => ({ email: email.email, channel, enabled: false }));
        const toAdd: UpsertBccEmailsRow[] = emails
          .filter((email) => !currentEmailsMap[email])
          .map((email) => ({
            email,
            channel,
            enabled: true,
          }));

        const mappedEmails = [...toDelete, ...toAdd];

        const results = await SetBccEmails({ channel, emails: mappedEmails });

        return results;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.bccEmails = action.payload.filter((bccEmail) => bccEmail.enabled);
        }
      },
    }
  );
};

export default updateBccEmailsReducer;
